// extracted by mini-css-extract-plugin
export default {"homeworkLine":"homeworkList_homeworkLine__kH9a3","empty":"homeworkList_empty__FdV3E"};